interface CatalogListActionVisibility {
  collection: boolean;
  wishlist: boolean;
}

export function catalogListActionVisibility(
  inCollection: boolean,
  inWishlist: boolean,
): CatalogListActionVisibility {
  if (inCollection && !inWishlist) return { collection: true, wishlist: false };
  return { collection: true, wishlist: true };
}
